import { useEffect, useState } from "react"
import { TranslationsStringsType } from "../../models/enum/rsvpEnum"
import { RsvpDetails, Settings, StepsTranslations } from "../../models/api/rsvpApiTypes"
import { useAppSelector } from "../../hook/useReduxHooks"
import { RootState } from "../../redux/store"
import { resolveTranslation } from "../../utils/translations"
import RsvpBox from "../RsvpBox"
import intolerancesStepIcon from "../../icon/intolerances-icon.svg"
import StepIntolerances from "./StepIntolerances"

interface StepIntolerancesBoxProps {
  settings: Settings
  rsvp: RsvpDetails
  setRsvp: (rsvp: RsvpDetails) => void
  stepPipeline: string[]
  setStep: (name: string) => void
}

export default function StepIntolerancesBox({ settings, rsvp, stepPipeline, setRsvp, setStep }: StepIntolerancesBoxProps) {
  const [intolerancesStrings, setIntolerancesStrings] = useState<StepsTranslations | undefined>({
    lang: "",
    strings: [],
  })
  const language = useAppSelector((state: RootState) => state.languageReducer.language).toLocaleLowerCase()

  useEffect(() => {
    const newIntolerancesStrings =
      resolveTranslation(settings.steps?.find((x) => x.name === "intolerances")?.translations ?? [], language)
    setIntolerancesStrings(newIntolerancesStrings)
  }, [language, settings.steps])

  return (
    <div className="box">
      <RsvpBox
        iconAlt="intolerancesStepIcon"
        iconSource={intolerancesStepIcon}
        title={intolerancesStrings?.strings.find((x) => x.type === TranslationsStringsType.TITLE)?.value}
        description={intolerancesStrings?.strings.find((x) => x.type === TranslationsStringsType.DESCRIPTION)?.value}
      >
        <StepIntolerances
          buttonColor={settings.rsvpStyle.buttonColor === null ? "#0c6efb" : settings.rsvpStyle.buttonColor}
          backButtonColor={settings.rsvpStyle.backButtonColor === null ? "#a6b7d4" : settings.rsvpStyle.backButtonColor}
          strings={intolerancesStrings?.strings}
          rsvp={rsvp}
          setRsvp={(rsvp) => setRsvp(rsvp)}
          setStep={(name) => setStep(name)}
          stepPipeline={stepPipeline}
        />
      </RsvpBox>
    </div>
  )
}
